import React from 'react';
import PropTypes from 'prop-types';
import { MuiTelInput } from 'mui-tel-input';
import { useTheme } from '@mui/material/styles';

import countries from '../../constants/countries';

const countryCodes = countries.map((c) => c.code);

const PhoneInput = ({ value, onChange, placeholder = 'Phone number' }) => {
  const theme = useTheme();

  return (
    <MuiTelInput
      value={value}
      onChange={onChange}
      defaultCountry="AU"
      onlyCountries={countryCodes}
      forceCallingCode
      fullWidth
      placeholder={placeholder}
      variant="outlined"
      label={null}
      sx={{
        '& .MuiOutlinedInput-root': {
          height: 40,
          borderRadius: '8px',
          backgroundColor: 'var(--color-surface)',

          '& fieldset': {
            borderColor: 'var(--color-border)',
          },

          '&:hover fieldset': {
            borderColor: 'var(--color-border)',
          },

          '&.Mui-focused fieldset': {
            borderColor: theme.palette.primary.main,
            borderWidth: '1px',
          },

          '& input': {
            fontSize: 14,
            color: theme.palette.text.primary,
            padding: '0 8px',

            '&::placeholder': {
              color: 'var(--color-text-muted)',
              opacity: 1,
            },
          },
        },

        '& .MuiInputAdornment-root': {
          marginRight: 0,
        },

        '& .MuiIconButton-root, & .MuiSvgIcon-root': {
          color: 'var(--color-text-muted)',
        },

        '& .MuiTelInput-FlagButton': {
          color: theme.palette.text.primary,
        },
      }}
    />
  );
};

PhoneInput.propTypes = {
  value: PropTypes.string,
  onChange: PropTypes.func.isRequired,
  placeholder: PropTypes.string,
};

export default PhoneInput;
